import ReactMarkdown, { Components } from 'react-markdown';
import { Box, Typography, Link } from '@mui/material';
import { DESIGN_TOKENS } from '../../styles/theme';

interface MarkdownRendererProps {
  content: string;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  const components: Components = {
    h1: ({ node, ref, ...props }) => <Typography variant="h3" component="h1" {...props} />,
    h2: ({ node, ref, ...props }) => <Typography variant="h4" component="h2" {...props} />,
    h3: ({ node, ref, ...props }) => <Typography variant="h5" component="h3" {...props} />,
    p: ({ node, ref, ...props }) => <Typography variant="body1" component="p" {...props} />,
    li: ({ node, ref, ...props }) => (
      <Typography component="li" variant="body1" sx={{ mb: 1 }} {...props} />
    ),
    a: ({ node, ref, ...props }) => <Link {...props} />,
  };

  return (
    <Box
      sx={{
        '& p': {
          mb: 2,
          lineHeight: 1.7,
        },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
          mt: 3,
          mb: 2,
          fontFamily: DESIGN_TOKENS.typography.fontFamilyDisplay,
          fontWeight: 600,
        },
        '& h1': { fontSize: '2rem' },
        '& h2': { fontSize: '1.75rem' },
        '& h3': { fontSize: '1.5rem' },
        '& ul, & ol': {
          mb: 2,
          pl: 3,
        },
        '& li': {
          mb: 1,
        },
        '& blockquote': {
          borderLeft: `4px solid ${DESIGN_TOKENS.colors.primaryLight}`,
          pl: 2,
          ml: 0,
          fontStyle: 'italic',
          color: 'text.secondary',
        },
        '& code': {
          backgroundColor: 'rgba(0,0,0,0.05)',
          padding: '2px 4px',
          borderRadius: '4px',
          fontSize: '0.9em',
        },
      }}
    >
      <ReactMarkdown components={components}>
        {content}
      </ReactMarkdown>
    </Box>
  );
};
